import React, { useRef, Suspense } from 'react';
import { Modal } from '@amzn/storm-ui';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { useSidenavBundle } from 'src/providers/PantherLocalizationProvider';

const QuickNavigationModal = React.lazy(
  () => import('@amzn/aac-quick-navigation-modal'),
);

const SideNavModal: React.VFC = () => {
  const { openModalAppName, setOpenModalAppName } = useConsolidatedNavContext();
  const buttonRef = useRef<HTMLButtonElement>();
  const bundle = useSidenavBundle();

  const closeModal = () => {
    setOpenModalAppName('');
  };

  return (
    <Modal
      isOpen={!!openModalAppName}
      onClose={closeModal}
      toggleEl={buttonRef.current}
      header={bundle.getMessage(
        `sidenav-modal-title-${openModalAppName?.toLowerCase()}`,
      )}
      modalElementId="AACChromePortal"
      data-ccx-e2e-id="aac-quick-nav-modal-close"
    >
      <Suspense fallback={<div>Loading...</div>}>
        <QuickNavigationModal type={openModalAppName} />
      </Suspense>
    </Modal>
  );
};

export default SideNavModal;
